import http from './request';
const isProd = !/sandbox|localhost|127\.0.0.1|10.1.200|10.1.161/i.test(location.hostname);

export default function errReport(target, message) {
  return Promise.resolve();
  // const data = {
  //   appId: 'M115', // 项目号
  //   uin: 'linghit_shield',
  //   message, //错误信息
  //   target, //错误目标接口或文件或组件
  //   from: location.href, //来源链接
  // };
  // console.error(data);
  // isProd && http.post('https://apm-collect.qiyuan333.cn/api/error', data);
}
